import React from "react";
import WalkThroughContent from "./WalkThroughContent";
import { Drawer } from "@mui/material";
import { useAssessmentWalkthrough } from "../../providers/AssessmentWalkthroughProvider";
import { Box } from "@mui/system";
import { useAssessment } from "../../providers/AssessmentProvider";

function AssessmentWalkThroughDrawerHandler({
  item,
  index,
  isMobile,
  showWalkhThroughDrawer,
  handleWalkThroughDrawer,
}) {
  const { showOrHideCheckBox, showOrHideAssessmentWalkthrough } =
    useAssessmentWalkthrough();
  const { drawerWidth } = useAssessment();
  return (
    <React.Fragment key={item.key + index}>
      {isMobile ? (
        <Drawer
          style={{ overflowY: "scroll" }}
          anchor="bottom" // Makes the drawer open from the bottom
          open={showWalkhThroughDrawer === item.key} // Controls whether the drawer is open or closed
          onClose={() => handleWalkThroughDrawer(null)}

          // Closes the drawer when clicking outside
        >
          {/* Drawer content */}
          <Box
            // role="presentation"
            sx={{
              textAlign: "center",
              backgroundColor: "#f1f1f1",
              maxHeight: "50vh",
              borderTopRightRadius: "10px",
              borderTopLeftRadius: "10px",
              overflowY: "scroll",
            }}
          >
            <WalkThroughContent
              item={item}
              handleWalkThroughDrawer={handleWalkThroughDrawer}
              showOrHideCheckBox={showOrHideCheckBox}
              showOrHideAssessmentWalkthrough={showOrHideAssessmentWalkthrough}
            />
          </Box>
        </Drawer>
      ) : (
        <div
          style={{
            display: showWalkhThroughDrawer === item.key ? "flex" : "none",
            backgroundColor: "white",
            position: "fixed",
            right: 0,
            width: drawerWidth,
            marginTop: "100px",
            height: "calc(100vh - 165px)",
            zIndex: 1,
            border: "1px solid #E0E0E0",
            overflowY: "scroll",
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              width: "330px",
            }}
          >
            <WalkThroughContent
              item={item}
              handleWalkThroughDrawer={handleWalkThroughDrawer}
              showOrHideCheckBox={showOrHideCheckBox}
              showOrHideAssessmentWalkthrough={showOrHideAssessmentWalkthrough}
            />
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}

export default AssessmentWalkThroughDrawerHandler;
